<template>
    <div class="checkout-delivery-shops">
        <div class="checkout-delivery-select">
            <DefSelectWrapper
                :toggle="true"
                :required="true"
                :value="getActiveShopName"
            >
                <template #header>
                    {{ getActiveShopName }}
                </template>

                <template #placeholder>
                    {{ messages.shop }}
                </template>

                <div
                    v-for="item in getShopsFilteredByCity"
                    :key="item.ID"
                    @click="changeData(item)"
                >
                    {{ item.TITLE }}
                </div>

            </DefSelectWrapper>


            <DefLink
                @click="isOpenMap = true"
                class="checkout-delivery-shops__link"
            >
                {{ messages.showOnMap }}
            </DefLink>
        </div>

        <DefSlideModal
            :active="isOpenMap"
            @close="isOpenMap = false"
        >
            <template #title>
                {{ messages.shopMap }}
            </template>
            <DefMap @handlerSelectShop="selectShopFromMap">
                <div
                    v-for="shop in getShopsFilteredByCity"
                    :lat="shop.GPS_N"
                    :lng="shop.GPS_S"
                    class="def-map-popup"
                >
                    <h6 class="def-map-popup__title">{{ shop.ADDRESS }}</h6>
                    <p class="def-map-popup__text">{{ shop.PHONE }}</p>
                    <p class="def-map-popup__text">{{ shop.SCHEDULE }}</p>
                    <button type="button" class="def-map-popup__button">
                        <span>{{ messages.choose }}</span>
                    </button>
                </div>
            </DefMap>
        </DefSlideModal>
    </div>
</template>

<script>
/**
 * Shops is filtered by current city
 * **/
import { mapActions, mapMutations, mapState } from 'vuex';
import DefSelectWrapper from "../../../def/DefSelect/DefSelectWrapper";
import DefLink from "../../../def/DefLink/DefLink";
import DefSlideModal from "../../../def/DefSlideModal/DefSlideModal";
import DefMap from "../../../def/DefMap/DefMap";

export default {
    name: 'CheckoutDeliveryShops',
    props: ['result', 'currentCity'],
    components: {
        DefSelectWrapper,
        DefLink,
        DefSlideModal,
        DefMap,
    },
    data() {
        return {
            isOpenMap: false,
            cityId: null
        }
    },
    computed: {
        ...mapState({
            inputStoreID: ({ checkout }) => checkout?.data?.vue?.delivery?.inputStoreID,
            requestData: ({ checkout }) => checkout?.data?.vue?.requestData,
            messages: ({ checkout }) => checkout.data.vue.delivery.messages,
        }),
        getActiveShopName() {
            // return this.result?.STORE?.find(el => el.CHECKED)?.TITLE;
            return this.requestData[ this.result.storeInputName ] || '';
        },
        /**
         * @todo сделать механику фильтрации городов после выбора из селекта любого города
         * @returns {*[]}
         */
        getShopsFilteredByCity() {
            return this.result?.STORE?.filter(el => el.UF_CITY == this.currentCity?.ID);
        }
    },
    methods: {
        ...mapActions({
            setAjax: 'checkout/setAjax',
        }),
        ...mapMutations({
            setRequestData: 'checkout/setRequestData'
        }),
        changeData(store) {
            this.setRequestData([
                { name: this.result.storeInputName, value: store.TITLE },
                { name: this.inputStoreID, value: store.ID }
            ]);
            this.setAjax();
        },
        selectShopFromMap({ lat, lng }) {
            const selectedShop = this.getShopsFilteredByCity.find(el => {
                if (el.GPS_N === lat && el.GPS_S === lng) {
                    return true;
                }
                return false;
            });

            this.changeData(selectedShop);
        }
    },
    mounted() {
        // TODO: check this action
        /**
         * reset selected shop
         * **/
        this.setRequestData([
            { name: this.inputStoreID, value: 0 }
        ]);
    }
}
</script>

<style lang="scss" scoped>
.checkout-delivery-shops{
    &__link{
        display: block;
        font-weight: 500;
        font-size: rem(12);
        line-height: 120%;
        margin-top: 16px;
        @include point-md{
            position: absolute;
            top: 50%;
            right: -24px;
            transform: translate(100%, -50%);
            margin-top: 0;
        }
    }
    :deep(.def-map){
        height: 100%;
    }
    :deep(.def-slide-modal__scroll){
        margin-bottom: 23px;
        @include point-md{
            margin-bottom: 28px;
        }
        @include point-lg{
            margin-bottom: 60px;
        }
    }
}
.checkout-delivery-select{
    @include point-md{
        position: relative;
    }
}
</style>